




























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    ADD_ANIMATION
} from "../store/mutations.names";

@Component({
    name: "PTextblock",

})
export default class PTextblock extends Vue {
    @Prop() public compData!: string | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
}
